function page (state = {
  page: 0,
}, action) {
  switch(action.type) {
    case 'PAGE_HANDER':
      return {
        page: action.data,
      }
    default:
      return state;
  }
}

export default page;


// WEBPACK FOOTER //
// ./src/reducer/action/page.js